import { object } from "yup";

import { dbIdValidationSchema } from "@dzambalaorg/yup-rules";

export const validationSchema = object().shape({
  contractId: dbIdValidationSchema,
  tokenId: dbIdValidationSchema,
});
